import { FieldDefinition, IEditableFormField } from 'types/form-types';

const isInputField = <DataModel>(
  fieldDefinition: FieldDefinition<DataModel>
): fieldDefinition is IEditableFormField<DataModel> => {
  return 'name' in fieldDefinition && !('calculate' in fieldDefinition);
};

export { isInputField };
